<template>
  <div class="sort-field">
    <v-select
      v-if="currentKey"
      :value="currentKey"
      :items="selectItems"
      :label="$t('message.reviewBooster.reviews.selectForm')"
      :title="$t('message.reviewBooster.reviews.selectForm')"
      item-text="name"
      item-value="key"
      :loading="isLoading"
      :disabled="isLoading"
      hide-details
      dense
      outlined
      append-icon="icon-arrow-down"
      class="sort-field__select"
      @change="handleChange"
    >
      <template v-slot:append-item>
        <div v-intersect="handleScroll"></div>
      </template>
    </v-select>
  </div>
</template>

<script>
import reviewBoosterService from "@/services/review-booster";
import serviceHandler from "@/helpers/handlers/service";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "ReviewBoosterSelectForm",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isLoading: false,
      isNextPageAvailable: true,
      currentKey: null,
      formList: [],
      page: 1
    };
  },
  computed: {
    selectItems() {
      const hasValue = this.formList.some(
        item => item.key === this.$route.query.reviewBoosterKey
      );
      return hasValue
        ? this.formList
        : [
            ...this.formList,
            {
              name: this.$route.query.reviewBoosterName,
              key: this.$route.query.reviewBoosterKey
            }
          ];
    }
  },
  async created() {
    await this.getReviewBoosterList();
    if (this.$route.query.reviewBoosterKey) {
      this.currentKey = this.$route.query.reviewBoosterKey;
    } else {
      this.currentKey = this.formList[0].key;
      const queries = { ...this.$route.query };
      this.$router.push({
        query: {
          ...queries,
          reviewBoosterKey: this.currentKey,
          reviewBoosterName: this.formList[0].name
        }
      });
    }
  },
  methods: {
    async getReviewBoosterList() {
      this.isLoading = true;
      const { results, next } = await serviceHandler(
        reviewBoosterService.getReviewBoosterList({ page: this.page })
      );
      this.formList.push(...results);
      this.isLoading = false;
      this.isNextPageAvailable = !!next;
    },
    handleChange(key) {
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.RB_REVIEW_LIST_FORM_SELECT,
        rb_id: key
      });
      const queries = { ...this.$route.query };
      this.$router.push({
        query: {
          ...queries,
          reviewBoosterKey: key,
          reviewBoosterName: this.formList.find(item => item.key === key).name
        }
      });
    },
    async handleScroll([intersection]) {
      if (!this.isNextPageAvailable) return;

      if (intersection.isIntersecting) {
        this.page += 1;
        await this.getReviewBoosterList();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.sort-field {
  width: 310px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
::v-deep .sort-field__select {
  width: 100%;
  height: 100%;
  flex-shrink: 0;

  &.v-text-field--outlined.v-input--dense.v-text-field--outlined {
    > .v-input__control {
      > .v-input__slot {
        padding-left: $spacing;
        padding-right: 0;
        min-height: 46px;
        height: 46px;
        @include font-size(14px);
        line-height: 17px;
        font-weight: normal;
      }
    }

    fieldset {
      border-color: rgba($text, 0.08);
      border-width: 1px;
      border-radius: $container-border-radius;
    }
  }

  &.v-text-field--outlined.v-input--dense.v-input--is-focused fieldset {
    border-color: $primary;
  }

  &.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
    .v-input__append-inner {
    width: 30px;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: $spacing * 1.5;
    padding-left: $spacing;
  }

  .v-select__selection--comma {
    margin-left: $spacing * 1.5 !important;
  }

  .v-label {
    @include font-size(14px);
    line-height: 17px;
    font-weight: normal;
    color: $dark-blue-3;
    padding-left: $spacing * 1.5;
    margin: $spacing / 8 0;
  }
}
</style>
